import { render, staticRenderFns } from "./EditAssignedLeadModal.vue?vue&type=template&id=b18c4ec2&"
import script from "./EditAssignedLeadModal.vue?vue&type=script&lang=js&"
export * from "./EditAssignedLeadModal.vue?vue&type=script&lang=js&"
import style0 from "./EditAssignedLeadModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports